export default __webpack_public_path__ + "static/media/480_business06-jp-web.c4776a4c.png";